/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1PrincipalState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_PRINCIPAL_STATE_ENTITY_NAME = 'ixc.registration.v1.Principal';
export const ixcRegistrationV1PrincipalStateEntity = new schema.Entity<IxcRegistrationV1PrincipalState>(IXC_REGISTRATION_V1_PRINCIPAL_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcRegistrationV1PrincipalState) => `${entity.principalId}-${entity.programId}` });

